import MessageAttachmentsList from "./MessageAttachmentsList";
import MessageDateItem        from "./MessageDateItem";
import MessageFlagsItem       from "./MessageFlagsItem";
import MessageRecipientItem from "./MessageRecipientItem";
import MessageRecipientsList  from './MessageRecipientsList';

export {MessageItem as default};

/**
* Message Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessageItem {
  /**
   * Message Id
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  id = 0;

  /**
   * Folder Id
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  folder_id;

  /**
   * Message subject
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  subject;

  /**
   * Message Sender
   *
   * @public
   *
   * @type {MessageRecipientItem}
   *
   * @since 7.0.0
   */

  sender = new MessageRecipientItem();

  /**
   * Sender label
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */

  sender_label;

  /**
   * Message date
   *
   * @public
   *
   * @type {MessageDateItem}
   *
   * @since 7.0.0
   */
  date = new MessageDateItem();

  /**
   * Full Recipients list
   *
   * @public
   *
   * @type {MessageRecipientsList}
   *
   * @since 7.0.0
   */
  recipients = new MessageRecipientsList();

  /**
   * Message Attachemnts
   *
   * @public
   *
   * @type {MessageAttachmentsList}
   *
   * @since 7.0.0
   */
  attachments = new MessageAttachmentsList();

  /**
   * Message Flags
   *
   * @public
   *
   * @type {MessageFlagsItem}
   *
   * @since 7.0.0
   */
  flags = new MessageFlagsItem();

  /**
   * Message Download Link
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  download;

  /**
   * Message Print id
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  print_id;

  /**
   * Message MDN
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  mdn = {
    requested : false,
    sent      : false,
  }

  /**
   * Message size
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  size;

  /**
   * Defines if message is invalid
   *
   * For example requesting a message that does not exist
   *
   * @public
   *
   * @type {boolean}
   *
   * @since 7.0.0
   */
  invalid = false;

  /**
   * Defines if message was fully fetched, or jsut the headers
   *
   * @public
   *
   * @type {boolean}
   *
   * @since 7.0.0
   */
  full_fetch = false;

  /**
   * Defines Body Parts
   *
   * @public
   *
   * @type {boolean}
   *
   * @since 7.0.0
   */
  body_parts = '';

  /**
   * Message Body elements
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  body = {}
}